import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Section } from '@/courses/models/section.model';
import { SERVER_HOSTNAME } from '@/shared/enums/request.enum';
import { AuthenticatedFileDownloadProvider } from '@/shared/providers/authenticated-file-download.provider';

@Component({
  name: 'ed-other-files-viewer'
})
export default class EdOtherFilesViewer extends Vue {

  @Prop() readonly section: Section;

  get fileName() {
    return this.section.assetsInfo ? this.section.assetsInfo[0].fileName : null;
  }

  get hash(){
    return this.section.assetsInfo ? this.section.assetsInfo[0].hash : null;
  }

  get ext(){
    return this.section.assetsInfo ? this.section.assetsInfo[0].fileName.split('.')[1] : null;
  }

  get isWebView(): boolean {
    return this.$store.state.AppStore.webview;
  }
  
  async downloadFile() {
    await AuthenticatedFileDownloadProvider.download(
      `${process.env[SERVER_HOSTNAME.COMMON]}/download/object/${this.ext}/${this.hash}/${this.fileName}`,
      this.fileName
    );
  }
  
}
